<template>
  <el-select
    v-model="internalValue"
    ref="remoteSelect"
    clearable
    filterable
    remote
    :remote-method="getRemoteData"
    @clear="getRemoteData('')"
    @focus="getRemoteData('')"
    :loading="loading"
    :placeholder="placeholder"
    class="wdb100"
    @change="handleChange"
  >
    <el-option
      v-for="(item, index) in dataList"
      :key="`business-info-remote-${index}-${item.businessNo}`"
      :label="`${item.businessNo}-${item.companyName}`"
      :value="item.businessNo"
    ></el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    // 接收父级 v-model 的值
    value: {
      type: String,
      default: "",
    },
    // 显示的占位符
    placeholder: {
      type: String,
      default: "Please Select",
    },
  },
  data() {
    return {
      loading: false,
      dataList: [],
    };
  },
  computed: {
    // 联动父级 v-model
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    // 远程搜索请求，后端默认返回前20条数据
    getRemoteData(query) {
      this.loading = true;
      this.$http
        .get("/admin/businessInfo/getList", {
          params: {
            keywords: query,
          },
        })
        .then(res => {
          const resData = res.data || [];
          this.dataList = resData;
        })
        .catch(err => {
          this.dataList = [];
        })
        .finally(() => {
          this.loading = false;
          // 解决首次搜索结果为[]时，下拉框空提示(No data)不出现的bug
          if (this.dataList.length === 0) {
            const selectComponent = this.$refs.remoteSelect;
            if (selectComponent) {
              // 欺骗组件：让它认为有搜索词，从而激活 No data 面板的渲染
              selectComponent.query = query || " ";
              // 强行把下拉面板撑开
              selectComponent.visible = true;
            }
          }
        });
    },
    // 选中值变化时，找出对应的完整对象并派发给父组件
    handleChange(val) {
      const selectedItem = this.dataList.find(item => item.businessNo == val);
      // 如果清空了选择，则返回 null
      this.$emit("change-item", selectedItem || null);
    },
  },
};
</script>
